import React, { useState, useEffect } from "react";
import { Table } from "antd";

import { formatDateTime } from "../../helpers/date";

const VoucherRedemptionList = (props) => {
  const [voucherRedemptions, setVoucherRedemptions] = useState(
    props.voucherRedemptions
  );

  useEffect(() => {
    setVoucherRedemptions(props.voucherRedemptions);
  }, [props.voucherRedemptions]);

  const table = [
    {
      title: "Merchant",
      dataIndex: ["merchant", "email"],
      render: (text) => text ? text : <span style={{ fontStyle: "italic" }}>[Deleted User]</span>
    },
    {
      title: "Voucher",
      dataIndex: ["voucher", "name"],
    },
    {
      title: "Order",
      dataIndex: ["order", "_id"],
      render: (text) => text ? text : "-",
    },
    {
      title: "Dispatched Date",
      dataIndex: "_created_at",
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "Redeemed Date",
      dataIndex: "redeemAt",
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "Redeemed Amount",
      dataIndex: "redeemAmount",
      render: (text, record) =>
        text ? `RM ${(text || record.voucher.amount).toFixed(2)}` : "-",
    },
    {
      title: "Expiry Date",
      dataIndex: "expireAt",
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
  ];

  return (
    <div className="table">
      <Table
        rowKey="objectId"
        className="table-section"
        columns={table}
        dataSource={voucherRedemptions}
        pagination={false}
        scroll={{ x: true }}
        loading={props.loading}
      />
    </div>
  );
};

export default VoucherRedemptionList;
